import React from 'react';
import { LinkProps, Link } from 'react-router-dom';

type ConfigurableLinkProps = LinkProps &
	React.RefAttributes<HTMLAnchorElement> & {
		disabled?: boolean;
	};
export function ConfigurableLink({ disabled, children, ...rest }: ConfigurableLinkProps) {
	if (disabled) {
		return <span>{children}</span>;
	}
	return <Link {...rest}>{children}</Link>;
}
